let module = angular.module('app.resources');

module.factory('Sites', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/sites`,
    {},
    {
      getSSOLink: {
        method: 'GET',
        url: `${API_ROOT}/sites/sso/link`,
      },
      getSites: {
        method: 'GET',
        isArray: true,
        url: `${API_ROOT}/account/sites/`,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/sites.js